module.exports = __webpack_public_path__ + "media/src/img/payment/webmoney-logo-fab76ab2da7535d7934f542d8b1ca84e.svg";